export const TLD = {
  CN: 'cn',
  JP: 'jp',
}

export const EVENT_SESSION_ID_COOKIE = 'event_session_id'
